import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import Table from "./Components/Table";
import { useNavigate, useParams } from "react-router-dom";
import Dashboard from "../../Dashboard";
import axios from "axios";
import AnalyzedProduct from "../dashbaord_main/AnalyzedProduct";
import { Label } from "flowbite-react";

const Product = () => {
  const [apiResponse, setApiResponse] = useState([]);
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [block, setBlock] = useState(false);
  const [filter, setFilter] = useState();
  const [search, setSearch] = useState("");
  const { id } = useParams();
  const [values, setValues] = useState({
    filterInput: "",
    minInput: "",
    maxInput: "",
  });

  console.log("values searchbar: ", search);

  const navigate = useNavigate();

  useEffect(() => {
    setValues({ filterInput: "", minInput: "", maxInput: "" });
  }, [filter]);

  useEffect(() => {
    handleSaveHistory();
  }, [search]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleChangeForSearch = (e) => {
    setError("");
    const { value } = e.target;
    setSearch(value);
  };

  const handleSaveHistory = async () => {
    try {
      axios
        .post("https://aipricingtool-python.onrender.com/get_saved_products", {
          user_identifier: id,
        })
        .then((response) => {
          setHistory(response.data);
          console.log(response.data);
        });
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    console.log(search);
    if (search === undefined || search == [] || search === "") {
      return null;
    } else {
      setBlock(true);
      setLoading(true);
      try {
        const res = await axios.post(
          "https://aipricingtool-python.onrender.com/searchdblist",
          { product_name: search, user_identifier: id }
        );
        console.log("res", res.data);
        setApiResponse(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error:", err);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const apiCheck = apiResponse.length > 0 ? false : true;

  return (
    <Dashboard>
      <div className="flex flex-col w-full  sm:w-auto sm:flex-row  sm:gap-5 justify-center align-center mb-3 product-main px-6 lg:px-0">
        <div className="flex flex-col  font-customFont  px-2 py-4 product-left w-full sm:w-[65%]  lg:w-[55%] xl:w-[60%] 2xl:w-[65%]">
          <div className="flex flex-col md:flex-row items-center justify-between  w-full left-inner">
            <div>
              <div className="flex items-center m-2 gap-3">
                <label className="primary text-xl  ">Filter </label>
                <select
                  id="filter"
                  disabled={apiCheck}
                  onChange={(e) => setFilter(e.target.value)}
                  className={`  px-4 py-1 w-auto item_bg ${
                    !apiCheck && "cursor-pointer"
                  } cursor-not-allowed rounded-lg text-lg text-white border-gray-300  border-0 border-b-2  appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
                >
                  <option selected default value="default">
                    Select
                  </option>
                  <option value="Price">Price</option>
                  <option value="Quantity">Quantity</option>
                </select>
              </div>
              {filter && filter === "Quantity" && (
                <div className="flex space-x-2 items-center">
                  <label>Quantity:</label>
                  <input
                    type="text"
                    name="filterInput"
                    value={values.filterInput}
                    disabled={apiCheck}
                    onChange={(e) => handleChange(e)}
                    maxLength={5}
                    onKeyDown={(e) => {
                      if (
                        !/^\d$/.test(e.key) &&
                        ![
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                          ".",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="rounded-xl border border-gray-200 shadow-md shadow-gray-300 focus:ring-0"
                  />
                </div>
              )}
              {filter && filter === "Price" && (
                <div className="flex space-x-2 items-center">
                  <label>Min:</label>
                  <input
                    type="text"
                    name="minInput"
                    maxLength={5}
                    value={values.minInput}
                    disabled={apiCheck}
                    onChange={(e) => handleChange(e)}
                    onKeyDown={(e) => {
                      if (
                        !/^\d$/.test(e.key) &&
                        ![
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                          ".",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="rounded-xl border w-1/4 border-gray-200 shadow-md shadow-gray-300 focus:ring-0"
                  />
                  <label>Max:</label>
                  <input
                    type="text"
                    name="maxInput"
                    maxLength={5}
                    value={values.maxInput}
                    disabled={apiCheck}
                    onChange={(e) => handleChange(e)}
                    onKeyDown={(e) => {
                      if (
                        !/^\d$/.test(e.key) &&
                        ![
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                          ".",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className="rounded-xl border w-1/4 border-gray-200 shadow-md shadow-gray-300 focus:ring-0"
                  />
                </div>
              )}
            </div>

            <div>
              <div className="search_bar bg-searchbar setting w-5/4  flex items-center  px-5   md:px-5  lg:px-2    !py-4 !gap-3 !rounded-full">
                <input
                  type="text"
                  name="searchbar"
                  value={search}
                  onChange={(e) => {
                    handleChangeForSearch(e);
                  }}
                  className="bg-white !focus:outline-none border-none w-full placeholder-placeholderColor p-0 focus:ring-0 "
                  placeholder="Search Here......."
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                />
                <Icon
                  icon="ri:search-line"
                  className="cursor-pointer"
                  color="#D76E3E"
                  width="20"
                  height="20"
                />
                <button
                  className={` text-[#D76E3E] rounded-lg w-[116px] Campton `}
                  onClick={handleSearch}
                >
                  Search
                </button>
              </div>
              {error && (
                <>
                  <p className="text-red-500 text-sm font-normal pl-11 mt-1">
                    {error}
                  </p>
                </>
              )}
            </div>
          </div>

          {apiResponse && (
            <div className="my-4 mx-2 setting px-2.5 py-3 product-table-main overflow-x-scroll lg:overflow-y-auto">
              <Table
                apiResponse={apiResponse}
                values={values}
                loading={loading}
                filter={filter}
                block={block}
              />
            </div>
          )}
          <div className="w-100 flex gap-x-14 my-5 justify-evenly">
            <button
              className={`py-2.5 text-white rounded-lg w-[116px] Campton `}
              style={{
                background:
                  "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
              }}
              onClick={() => navigate(`/dashboard/${id}`)}
            >
              {"<"} Back
            </button>
          </div>
        </div>

        <div className="font-customFont w-full sm:w-[35%]  lg:w-[45%] xl:w-[40%] 2xl:w-[35%]  flex flex-col items-center px-4 ">
          <AnalyzedProduct
            hide="d-none"
            heading="HISTORICAL ITEMS"
            setValues={setValues}
            values={values}
            setError = {setError}
            setSearch={setSearch}
            apiResponse={apiResponse}
          />
        </div>
      </div>
    </Dashboard>
  );
};

export default Product;
